<template>
  <div class="book-cards" style="cursor: pointer" @click="boxClick(info)">
    <div class="back-box">
      <!-- <slot name="columnBook" class="box-slot"></slot> -->
      <img
        :class="props.info.img_type === 2 ? 'bigwidth3' : ''"
        class="big-img"
        width="90px"
        v-complete:src="props.info.img_url"
        alt=""
      />
    </div>
    <div class="box-content">
      <p>{{ info.title }}</p>
      <slot name="line"></slot>
      <section class="section-box">
        <p>
          <span :style="{ color: props.leftColor }">学科：</span>
          <span
            v-for="(item, index) in props.info.apply_subject"
            :key="index"
            style="color: #333; margin-right: 2px"
          >
            {{ item }}
          </span>
        </p>
        <p>
          <span :style="{ color: props.leftColor }">适用年级：</span
          >{{ props.info.grade }}
        </p>
        <p>
          <span :style="{ color: props.leftColor }">适用地区：</span>
          <span
            style="color: #333333"
            v-for="(item, index) in props.info.apply_area"
            :key="index"
          >
            {{ item.city_name }}
          </span>
        </p>
      </section>
      <!-- <p>
        {{ props.info.description ? props.info.description : props.info.title }}
      </p> -->
    </div>
  </div>
</template>

<script setup>
import { reactive } from "vue";
import { useRouter } from "vue-router";
const router = useRouter();

const mydata = reactive({
  // 基础地址
  VUE_APP_BASE_HOST: process.env.VUE_APP_BASE_HOST,
});
const props = defineProps({
  info: {
    type: Object,
    default: () => {
      return {};
    },
  },
  leftColor: {
    type: String,
    default: "#007ad8",
  },
});

function boxClick(val) {
  if (!val.outPage) {
    router.push({
      path: "/layout/list/booksDetails",
      query: { id: val.id },
    });
  } else {
    if (val.path) {
      window.open(val.path);
    }
  }
}
</script>

<style scoped lang="scss">
.book-cards {
  width: 150px;
  // width: 250px;
  // height:250px;
  //  border:1px solid pink;
  // >.box-slot{
  //     width:100%;
  //     height:272px;
  //     border:1px solid red;
  //     >img{
  //         width:100%;
  //         height:100%;
  //     }
  // }
  .back-box {
    width: 150px;
    height: 150px;
    border-radius: 8px;
    background-color: #eeeeee;
    display: flex;
    justify-content: center;
    align-items: center;
    .big-img {
      width: 90px;
      // height: 187px;
      // margin-left:55px;
      // margin-top:30px ;
    }
  }
  .box-content {
    width: 150px;
    // height: 130px;
    margin-top: 5px;
    // border:1px solid rgb(0, 38, 255);
    > p:nth-of-type(1) {
      font-size: 16px;
      font-weight: 400px;
      // line-height: 24px;
      color: #ffffff;
      margin-bottom: 5px;

      line-height: 24px;
      white-space: nowrap !important; //不折行
      text-overflow: ellipsis !important; //文本溢出 用省略号显示
      overflow: hidden !important;
    }
    >p:hover {
      // color: #009de0 !important;
      font-weight: 550 !important;
    }
    // > p:nth-of-type(2) {
    //   font-size: 14px;
    //   font-weight: 400px;
    //   // line-height: 22px;
    //   color: #ffffff;

    //   line-height: 22px;
    //   display: -webkit-box;
    //   -webkit-box-orient: vertical; // 从上向下垂直排列子元素。设置或检索伸缩盒对象的子元素的排列方式 。
    //   text-overflow: ellipsis; //文本溢出 用省略号显示
    //   -webkit-line-clamp: 4; //几行
    //   overflow: hidden;
    // }
  }
}
.section-box {
  // border: 1px solid red;
  > p {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 14px;
    // margin: 20px 0;
    margin: 8px 0;
    height: auto !important;
    color: #333333;
    > span {
      color: #007ad8;
    }
  }
}
</style>
